export const locale = {
  GLOBAL: {
    Title: "بيامك لاند",
    PostalCode: "البوستال كود",
    postalCodes: "البوستال كودات",
    selectedPostalCodes: "البوستال كودات المختارة",
    MciNumberCount: "عدد خطوط همراه أول",
    MtuNumberCount: "عدد خطوط إيرانسل",
    TotalCount: "العدد الكلي",
    Coefficient: "المعامل",
    Back: "رجوع",
  },
  ERRORS: {
    PhoneIsNotValid: "الرقم اللي دخلته مو صحيح يمعود: مثلاً 09101234567",
    InvalidNumber: "العدد اللي دخلته مو زين",
    NoSelectedLineNumber: "اختار خط المرسل يمعود!",
    EmptyText: "اكتب النص يمعود ماكو شي",
    UnknownError: "خطأ ما نعرف شنو صاير",
    TryAgain: "جرب مرة ثانية بعد شوية",
    NoAccountCharge: "فلوسك خلصت يمعود",
    NoAccess: "ما عندك صلاحية حبيبي",
    PleasebyeAPlane: "اشتري باقة يلا",
    PleaseChargeYourAccount: "شحن حسابك بسرعة",
    AccessDenied: "ممنوع الدخول",
    AccessDeniedDescription: "إذا تريد معلومات زيادة راسل الدعم",
    Error: "خطأ",
    InvalidText: "النص مو زين",
    InvalidTextContainsLink: "بس الخطوط الخدمية تقدر تحط لينك",
  },
  INFOS: {
    SuccessSentSms: "الرسالة طلعت تمام يا زلمة",
    SmsRequestInQueue: "رسالتك بعد ما يوافق المدير تطلع",
    SendData: "بيانات الإرسال",
    CheckData: "شوف اللي تحت وأكد عليه",
  },
  TOBE: {
    to: "لـ ",
    from: "من ",
  },
  FORMS: {
    DestinationPhone: "رقم المستلم",
    TestDestinationPhone: "رقم التجربة",
    SourceNumber: "رقم المرسل",
    Text: "النص",
    CharCount: "عدد الحروف",
    FarsiCharCount: "عدد الحروف الفارسية",
    EnglishCharCount: "عدد الحروف الإنكليزية",
    Send: "إرسال",
    SendTime: "وقت الإرسال",
    SendTest: "إرسال تجريبي",
    SendToTestNumber: "إرسال للرقم التجريبي",
    SmsCount: "عدد الرسايل",
    SmsLang: "لغة الرسالة",
    Add: "ضيف",
    FromFile: "ضيف من ملف",
    TestNumber: "الرقم التجريبي",
    Test: "تجربة",
    ServiceRelated: "خط خدمي",
    Price: "السعر",
    NumbersCount: "عدد الأرقام",
    NumbersCountToSend: "عدد اللي بيوصلهم الرسايل",
    Search: "دور",
    Title: "العنوان",
    RequestTime: "وقت الطلب",
    RequestInformation: "معلومات الطلب",
    CreateNewPhoneBook: "افتح دفتر تلفون جديد",
  },
  BUTTONS: {
    OK: "تمام",
    AccountCharge: "شحن الحساب",
    Reports: "التقارير",
    RemoveAll: "امسح الكل",
    BuyAPlane: "اشتري باقة",
    Accept: "اوكي",
    Reject: "لاء",
    Yes: "أي",
    No: "لا",
    Create: "خلّق",
    New: "جديد",
    Save: "حفظ",
    Delete: "امسح",
    More: "زود",
    TryAgain: "جرب مرة ثانية",
    Close: "سكّر",
    RollBack: {
      back: "ارجع للي قبله",
      goToMainUser: "ارجع للحساب الرئيسي",
      CurrentUser: "الحساب الحالي",
    },
  },
  DIALOGS: {
    Waiting: "استنى شوية",
    RejectItQuestion: "ترفضه؟",
    AcceptItQuestion: "توافق؟",
    Rejected: "رفضناه",
    Accepted: "وافقنا",
    Error: "خطأ",
  },
  CONFIRM: {
    Delete: "متأكد تريد تمسحه؟",
    DeleteA: "متأكد تريد تمسح {a}؟",
    DeleteALL: "متأكد تريد تمسح الكل؟",
  },
  LANGUAGE: {
    English: "إنكليزي",
    Persian: "فارسي",
  },
    language: {
    selectAll: "اختر الكل",
    lang: {
      fa: "الفارسية",
      ar: "العربية",
      ar_ae: "العربية (الإمارات)",
      ar_iq: "العربية (العراق)",
      en_US: "الإنجليزية (أمريكا)",
      en_GB: "الإنجليزية (بريطانيا)",
      de: "الألمانية",
      fr: "الفرنسية",
      zh_CN: "الصينية المبسطة",
      zh_TW: "الصينية التقليدية",
      tr: "التركية",
      ru: "الروسية",
      hy: "الأرمنية",
    },
    only_manual_now: "هسة بس الترجمة اليدوية موجودة",
    ai_coming_soon: "ترجمة الذكاء الاصطناعي قريب راح تشتغل",
    got_it: "فهمت",
    origin_language: "اللغة الأصلية",
    target_languages: "اللغات المستهدفة",
    remove_all: "احذف كل اللغات",
    translation_method: "اختر طريقة الترجمة",
    manual_translation: "ترجمة يدوية",
    ai_translation: "ترجمة ذكاء اصطناعي",
    coming_soon: "قريب",
    source_language_updated: "اللغة الأصلية اتغيرت",
    error_changing_source_language: "صار خطأ بتغيير اللغة الأصلية",
    source_language_created: "لغة أصلية جديدة انخلقت",
    languages_saved: "اللغات الجديدة انحفظت",
    error_saving_languages: "صار خطأ بحفظ اللغات",
    error_loading_language: "صار خطأ بتحميل اللغة",
    languages_removed: "اللغات المحذوفة",
    new_languages_to_save: "لغات جديدة لازم تنحفظ",
    saved: "انحفظ",
    management_langs: "إدارة اللغات",
    add_langs: "أضف لغة",
    change_language: "غيّر اللغة",
    visit_card: "كارت الزيارة",
    translate_to: "ترجم لـ",
    main_language: "اللغة",
    no_languages_available: "ماكو لغات موجودة",
    return_to_default: "ارجع للغة الأصلية",
    translate: "ترجم",
    changes_pending: "بانتظار تطبيق التغييرات",
    apply_changes: "تطبيق التغييرات",
    cancel_changes: "إلغاء",
  },

  LISTS: {
    NoData: "ماكو شي",
    NoDataFound: "ما لكينا شي",
    NoDataFoundFor: "ما لكينا شي على {a}",
    NoPhoneNumber: "ماكو رقم",
    NoPostalCode: "ماكو بوستال كود",
    AddANumber: "ضيف رقم",
    City: "المدينة",
    AddedBefore: "مضاف من قبل",
  },
  PAGES: {
    SendSms: "إرسال رسايل",
    MapSms: "إرسال بالخريطة",
    PhoneBook: "دفتر التلفون",
  },
  MONETARY: {
    Rial: "ريال",
  },
  HINTS: {
    SendMessageTitle:
      "العنوان بس اسم تختاره، تقدر تستخدم عناوين الرسايل القديمة حتى يتعبّى النص أوتوماتيك. العنوان ما يطلع بالرسالة، يستخدمونه بالتقارير والاقتراحات.",
    SendMessageTime:
      "وقت الإرسال هو وقت ما تدخل الرسالة قائمة الإرسال. انتبه، ما تطلع إلا بعد موافقة المدير.",
    CreatePhoneBook:
      "هذا الاسم يطلع لك لما تضيف أرقام من دفتر التلفون وانت ترسل.",
  },
  TOASTS: {
    SuccessCreate: "صار تمام",
    FailedCreated: "ما صار",
    SuccessDelete: "تمسّح",
    FailedDelete: "ما تمسّح",
    SuccessEdit: "تعدل تمام",
    FailedEdit: "ما تعدّل",
    AddedSuccess: "ضاف",
    AddedFailed: "ما ضاف",
  },
  WALLET: {
    CustomCharge: "مبلغ على كيفك",
    GateWay: "بوابة الدفع",
    Price: "المبلغ",
    Details: [
      "٩٪ ضريبة بتضاف على المبلغ.",
      "تأكد من المبلغ زين، اللي تدفعه ما يرجع.",
    ],
    noGateWay: "ما عندك بوابة دفع.",
    PriceNotInRange: "المبلغ لازم يكون بين {min} و {max} ريال.",
    Pay: "ادفع",
    ErrorOnRedirectToGateWay: "صار خطأ وانت تروح لبوابة الدفع",
    ChargeWalletButtonDescription: "اضغط على + حتى تشحن حسابك",
  },
  login: {
    phoneField: {
      placeholderIran: "ابدي بـ 9 (مثل +98 912 345 6789)",
      placeholderDefault: "دخل رقمك",
      maxDigitsError: "أكثر شي {count} أرقام!",
      iranMustStartWith9: "الجوال لازم يبدي بـ 9 (مثل 912…)",
    },
    signup_button: "سجل يلا!",
    forget_password_title: "نسيت الباسوورد",
    register_title: "تسجيل مجاني",
    login_title: "دخول",
    back: "رجوع",
    username_label: "الجوال أو اسم المستخدم",
    otp_resend_button: "ارسل الرمز مرة ثانية",
    password_label: "الباسوورد",
    password_hint: "على الأقل 8 حروف",
    name_label: "الاسم",
    name_rule: "على الأقل 3 حروف",
    lastname_label: "اللقب",
    phone_label: "الجوال",
    nid_label: "الرقم الوطني",
    parent_phone_label: "جوال المعرف (اختياري)",
    terms_and_conditions_message:
      "التسجيل يعني وافق على شروط ترمينال الإعلانات.",
    terms_and_conditions_link: "الشروط والأحكام",
    close: "سكّر",
    forgot_password_link: "نسيت الباسوورد؟",
    change_password: "غيّر الباسوورد",
    register_button: "تسجيل",
    login_button: "دخول",
    login_with_google: "دخول بكوكل",
    login_with_sms: "دخول برسالة",
    login_with_password: "دخول بباسوورد",
    already_registered: "مسجل من قبل؟",
    login_here: "ادخل هنا",
    no_account: "ما عندك حساب؟",
    signup_now: "سجل الحين!",
    more_info: "معلومات زيادة",
    text_login: "دخول",
    text_register: "تسجيل",
    required_field: "هذا الحقل لازم تملاه.",
    min_8_char: "قليل أقل من 8 حروف",
    required: "لازم تملاه",
    min_3_char: "على الأقل 3 حروف",
    max_50_char: "أكثر شي 50 حرف",
    no_internet: "ما عندك نت",
    no_phone_entered: "ما دخلت رقم",
    otp_sent_successfully: "الكود وصلك تمام",
    please_register_first: "سجل الأول يمعود!",
    wait_3_min: "استنى 3 دقايق وبعدين جرب",
    login_successful: "دخلت تمام",
    internet_connection_error: "مشكلة بالنت!",
    agree_to_terms_error: "ما وافقت على الشروط!",
    otp_sent_successfully_register: "الكود وصل تمام",
    error: "خطأ",
    registration_nid_required_notice:
      "عشان الأمان ومنع الغش، لازم تدخل الرقم الوطني وانت تسجل بترمينال الإعلانات.",
  },
  home: {
    title: "الرئيسية",
    selectSystem: "اختيار النظام",
    yourPoints: "نقاطك",
    discountCodes: "أكواد الخصم",
    all: "الكل",
    discounts: "الخصومات",
    systemGuide: "دليل النظام",
    yourPointsDynamic: "نقاطك: {points}",
    confirm: "تأكيد",
    copy: "نسخ",
  },
  badges: {
    free: "مجاني",
    preRegister: "تسجيل مسبق",
    comingSoon: "قريبًا",
    testVersion: "نسخة تجريبية",
  },
  services: {
    qrLand: {
      title: "نظام كيو آر لاند",
      description: "إنشاء كود QR ديناميكي",
      property: {
        0: "مراجعة واختيار نوع وموقع الإعلان",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا داعي لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    payamak: {
      title: "نظام بيامك لاند",
      description: "إرسال رسائل ترويجية جملة",
      property: {
        0: "إرسال رسائل SMS جملة",
        1: "بنك أرقام محدث",
        2: "إرسال رسائل لنادي العملاء",
        3: "إمكانية الربط بجميع المواقع والبرامج",
      },
    },
    robot: {
      title: "نظام روبوت لاند",
      description: "إدارة جميع الأرقام والإعلانات واللوحات في وقت واحد",
      property: {
        0: "نشر إعلانات جماعية وكثيفة",
        1: "إدارة الإعلانات بطريقة زمنية وتدريجية وذكية",
        2: "إيجار وإضافة أرقام غير محدودة لنشر الإعلانات",
        3: "تسجيل وإدارة كل الإعلانات في نفس الوقت",
      },
    },
    infoLand: {
      title: "إنفو لاند",
      description: "أكثر من 2500 قاعدة بيانات مهن حديثة",
      property: {
        0: "يحتوي على كل المعلومات المهنية",
        1: "تصنيف كل المدن والمحافظات",
        2: "قاعدة بيانات وطنية لكل المهن",
        3: "إمكانية معاينة عينات من كل القواعد",
      },
    },
    graphic: {
      title: "نظام جرافيك لاند",
      description: "من الصفر إلى المئة في التصميم الجرافيكي والفيديو",
      property: {
        0: "تصميم الشعار والأدوات الإدارية",
        1: "كل خدمات الطباعة والتغليف",
        2: "تصميم الكتالوج والبروشور والعلب",
        3: "تصميم وطباعة جميع أنواع البانرات بمقاسات مختلفة",
      },
    },
    bestWebLand: {
      title: "نظام بست ويب لاند",
      description: "تصميم المواقع ودعمها وتحسين محركات البحث",
      property: {
        0: "تحسين المحتوى",
        1: "تحسين خارج الصفحة",
        2: "تحسين تقني",
        3: "تحسين داخل الصفحة",
      },
    },
    onlineShop: {
      title: "منشئ المتجر الإلكتروني",
      description: "بضع نقرات فقط وأنت في العالم الرقمي",
      badge: "بيع بالعمولة",
      property: {
        0: "تحسين المحتوى",
        1: "تحسين خارج الصفحة",
        2: "تحسين تقني",
        3: "تحسين داخل الصفحة",
      },
    },
    social: {
      title: "الإعلانات في وسائل التواصل الاجتماعي",
      description: "مراجعة واختيار أفضل الصفحات والقنوات",
      property: {
        0: "مراجعة كل الصفحات ذات الزيارات العالية",
        1: "إدارة موحدة لكل الإعلانات المشمولة",
        2: "لا داعي لدفع عمولة أو رسوم إضافية",
        3: "تسجيل طلب الإعلان أونلاين في الصفحات المختارة",
      },
    },
    billboard: {
      title: "تأجير لوحات إعلانية أونلاين",
      description: "بدون وسطاء وباختيار مستهدف للوحة",
      property: {
        0: "مراجعة موقع ونوع اللوحة",
        1: "إدارة كل اللوحات المشمولة",
        2: "تواصل مباشر وبدون وسطاء مع صاحب اللوحة",
        3: "لا داعي لدفع عمولة أو رسوم إضافية",
      },
    },
    internationalMedia: {
      title: "الإعلانات في الإعلام الوطني",
      description: "مراجعة ونشر الإعلانات في التلفزيون والراديو",
      property: {
        0: "مراجعة واختيار وقت بث الإعلان",
        1: "مراجعة واختيار أنواع الإعلانات التلفزيونية",
        2: "مراجعة واختيار أنواع الإعلانات الإذاعية",
        3: "مراجعة واختيار إعلان حسب نوع البرنامج",
      },
    },
    transport: {
      title: "الإعلانات في أسطول النقل",
      description: "المطارات، محطات القطار، الحافلات والمترو",
      property: {
        0: "مراجعة واختيار نوع وموقع الإعلان",
        1: "مراجعة واختيار أنواع إعلانات المترو",
        2: "لا داعي لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لكل الإعلانات الموضوعة في المترو",
      },
    },
    cinema: {
      title: "الإعلانات في الوسائط المرئية",
      description: "نشر الإعلانات في السينما ومواقع مشاركة الفيديو",
      property: {
        0: "مراجعة واختيار نوع وموقع الإعلان",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا داعي لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لكل الإعلانات الموضوعة في السينما",
      },
    },
    estate: {
      title: "نظام العقارات أونلاين",
      description: "إدارة الملفات والاستشاريين والعملاء",
    },
    AIGeneration: {
      title: "نظام الذكاء الاصطناعي",
      description: "إنشاء صور، شات بوت",
    },
    ShortLink: {
      title: "نظام الروابط القصيرة",
      description: "إنشاء رابط قصير",
    },
    customer: {
      title: "نظام إدارة العملاء أونلاين",
      description: "إدارة ودعم وإنشاء عملاء مخلصين",
    },
    internetBroadcasting: {
      title: "إدارة الإعلانات على الإنترنت",
      description: "إعلانات جوجل، إعلانات نقرة، ريبورتاج",
    },
    emailMarketing: {
      title: "نظام التسويق عبر الإيميل",
      description: "إرسال إيميل ترويجي لكل المهن في البلد",
    },
    adsOnStudium: {
      title: "إعلانات الملاعب والمعارض",
      description: "وجود علامتك التجارية في أكبر المراكز",
    },
    bidOnline: {
      title: "نظام المزادات الشامل أونلاين",
      description: "إنشاء مزادات، المشاركة في المزادات",
    },
    onlineTools: {
      title: "نظام أدوات الأعمال أونلاين",
      description: "كل الأدوات المساعدة لأي نوع من الأعمال",
    },
    onlineLearn: {
      title: "نظام التعليم أونلاين للأعمال",
      description: "مراجعة واختيار دورات تدريبية مستهدفة",
    },
    cloud: {
      title: "الهوستينج وشراء الدومين",
      description: "شراء هوست، دومين وسيرفر",
    },
    QrlandShop: {
  title: "إدارة المتاجر الإلكترونية",
  description: "إدارة متكاملة للمنتجات والأسواق الإلكترونية والتسعير الذكي",
  property: {
    0: "متابعة وإدارة شاملة للمنتجات",
    1: "إدارة خيارات المنتجات",
    2: "متابعة الأسواق الإلكترونية وإدارتها",
    3: "استراتيجيات التسعير الذكي",
  },
},

  },
  "planning.title": "التخطيط",
  "tabs.reminder": "التذكيرات",
  "tabs.notes": "الملاحظات",
  "tabs.calendar": "التقويم",
  "notes.creationDate": "تاريخ الإنشاء",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "actions.quickActions": "إجراءات سريعة",
  "notes.writeMessage": "كتابة ملاحظة",
  "notes.titlePlaceholder": "عنوان الملاحظة",
  "notes.addNote": "إضافة ملاحظة",
  "notes.updatedSuccess": "تم تحديث الملاحظة بنجاح.",
  "notes.addedSuccess": "تم إضافة الملاحظة بنجاح.",
  "common.deletedSuccess": "تم الحذف بنجاح",
  "common.confirmDelete": "متأكد من الحذف؟",
  "news.title": "أخبار الموقع",
  "news.noNews": "ماكو أي خبر منشور بالموقع.",
  "news.view": "شوف",
  "remember.add": "إنشاء تذكير",
  "remember.update": "تحديث التذكير",
  "remember.titleLabel": "العنوان",
  "remember.dateLabel": "تاريخ التذكير",
  "remember.confirmDelete": "متأكد من الحذف؟",
  "remember.deleteSuccess": "تم حذف التذكير بنجاح.",
  "remember.createSuccess": "تم إنشاء تذكير جديد.",
  "remember.updateSuccess": "تم تحديث التذكير.",
  "points.receivedAwards": "الجوائز اللي وصلتك",
  "points.pointsHistory": "سجل النقاط",
  "points.points": "نقاط",
  "points.discountTitle": "خصم روبوت لاند",
  "points.discountText": "لكل 500 نقطة",
  events: {
    title: "الأحداث",
    addEvent: "إضافة حدث",
    calendar: "التقويم الأساسي",
    close: "إغلاق",
    save: "حفظ",
    update: "تحديث",
    confirmDelete: "متأكد من الحذف؟",
    successAdd: "تمت الإضافة بنجاح.",
    successDelete: "تم حذف الحدث بنجاح.",
    successUpdate: "تم التحديث بنجاح.",
    titleLabel: "العنوان",
    descriptionLabel: "الوصف",
    colorLabel: "اللون",
    removeAfterDrop: "إزالة بعد السحب",
    createEvent: "إنشاء حدث",
  },
  copySuccess: "انسخ بنجاح.",
  copyTextTitle: "نسخ النص",
  copiedTextTitle: "انسخ",
  ribbon: {
    new: "جديد",
  },
  coupons: [
    { text: "هذا الكوبون صالح لمدة 3 أسابيع", title: "نص غير متكرر 20%" },
    { text: "هذا الكوبون صالح لمدة أسبوعين", title: "تصميم موقع 5%" },
    {
      text: "هذا الكوبون يمكن استخدامه مرة واحدة فقط",
      title: "إدارة الصفحة 10%",
    },
    { text: "هذا الكوبون مفعّل لك بشكل دائم", title: "تصميم جرافيك 5%" },
    { text: "هذا الكوبون يمكن استخدامه مرة واحدة فقط", title: "طباعة 2%" },
  ],
  userLinks: {
    profile: {
      title: "نظرة عامة",
      invitation: { title: "دعوة الأصدقاء" },
      info: { title: "المعلومات الشخصية" },
      edit: { title: "استكمال الملف" },
      changePass: { title: "تغيير كلمة المرور" },
    },
  },
  profileLinks: {
    orders: "الطلبات",
    addresses: "العناوين",
  },
  customPage: {
    overview: "نظرة عامة",
    personalInfo: "المعلومات الشخصية",
    changePassword: "تغيير كلمة المرور",
    completeProfile: "استكمال الملف",
    email: "الإيميل",
    balance: "الرصيد",
    phone: "رقم الهاتف",
    rial: "ريال",
  },
  widget12: {
    inviteFriends: "دعوة الأصدقاء",
    viewInvitedUsers: "عرض قائمة المستخدمين اللي دعيتهم",
    yourInviteCode: "كود دعوتك",
    createNewUser: "إنشاء مستخدم جديد",
    copyText: "نسخ",
    userCreatedSuccess: "تم إنشاء المستخدم الجديد بنجاح",
    notCreated: "ما انخلق",
  },
  userInfo: {
    userInformation: "معلومات المستخدم",
    profilePicture: "صورة الملف الشخصي",
    allowedFileTypes: "الصيغ المسموحة: png، jpg، jpeg.",
    profilePictureSize: "الصورة لازم تكون مربعة (مثلًا 480×480).",
    firstName: "الاسم",
    lastName: "اللقب",
    username: "اسم المستخدم",
    phone: "رقم الجوال",
    email: "الإيميل",
    receiveSMS: "استقبال الرسائل",
    smsCostNote: "لو فعّلت هالخيار بيخصمون تكلفة الرسائل من حسابك.",
    saveChanges: "حفظ التغييرات",
    profileUpdated: "تم تحديث ملفك بنجاح.",
  },
  emailSettings: {
    completeProfile: "استكمال الملف",
    completeProfileDesc: "استكمال معلومات الشخص أو المؤسسة",
    cancel: "إلغاء",
    update: "تحديث",
    save: "حفظ",
    selectPersonType: "اختار نوع الشخص؟",
    realPerson: "شخص عادي",
    legalPerson: "شركة أو مؤسسة",
    phone: "الجوال",
    landline: "التلفون الأرضي",
    fatherName: "اسم الأب",
    nationalCode: "الرقم الوطني",
    idNumber: "رقم البطاقة",
    birthday: "تاريخ الميلاد",
    placeOfBirth: "مكان الولادة",
    postalCode: "البوستال كود",
    email: "الإيميل",
    introduction: "شلون عرفت علينا؟",
    nationalCodePic: "صورة البطاقة الوطنية",
    plaque: "رقم اللوحة",
    address: "العنوان الكامل",
    companyName: "اسم الشركة أو المحل",
    registrationNumber: "رقم التسجيل",
    economicCode: "الكود الاقتصادي",
    organizationIdentity: "الرقم الوطني للشركة",
    companyType: "نوع الشركة",
    activity: "مجال النشاط",
    registrationAd: "صورة إعلان تسجيل الشركة",
    lastPublishedAd: "صورة آخر إعلان رسمي",
    statute: "صورة النظام الأساسي",
    agentLetterPic: "صورة خطاب تعريف الوكيل",
    successMessage: "حفظ تمام",
    errorSelectType: "اختار واحد يمعود",
    rules: {
      companyName: "حقل اسم الشركة أو المحل مطلوب.",
      registrationNumber: "حقل رقم التسجيل مطلوب.",
      economicCode: "حقل الكود الاقتصادي مطلوب.",
      organizationIdentity: "حقل الرقم الوطني للشركة مطلوب.",
      registrationAd: "صورة إعلان التسجيل مطلوبة.",
      lastPublishedAd: "صورة آخر إعلان رسمي مطلوبة.",
      telephone: "حقل الرقم الأرضي مطلوب.",
      fatherName: "حقل اسم الأب مطلوب.",
      nationalCode: "حقل الرقم الوطني مطلوب.",
      birthday: "حقل تاريخ الميلاد مطلوب.",
      idNumber: "حقل رقم البطاقة مطلوب.",
      placeOfBirth: "حقل مكان الولادة مطلوب.",
      postalCode: "حقل البوستال كود مطلوب.",
      nationalCodePic: "صورة البطاقة الوطنية مطلوبة.",
      address: "حقل العنوان مطلوب.",
      plaque: "حقل رقم اللوحة مطلوب.",
    },
    companyTypes: {
      governmental: "حكومي",
      private: "خاص",
      commonStock: "مساهمة عامة",
      specialStock: "مساهمة خاصة",
    },
  },
  changePassword: {
    title: "تغيير كلمة المرور",
    description: "غير كلمة مرور حسابك",
    cancel: "إلغاء",
    update: "تحديث",
    currentPassword: "كلمة المرور القديمة",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    successMessage: "كلمة المرور تغيرت تمام",
  },
  router: {
    dashboard: "لوحة التحكم",
    contacts: "نادي العملاء",
    editContact: "تعديل العميل",
    createContact: "إنشاء عميل",
    customers: "قائمة العملاء",
    contactList: "مساعد الاتصال",
    messages: "الرسائل",
    messageCategories: "تصنيف الرسائل",
    oldTransactions: "المعاملات القديمة",
    yourTransactions: "معاملاتك",
    buyPanel: "شراء لوحة",
    permissions: "الصلاحيات",
    invitations: "قائمة الدعوات الخاصة بي",
    editUser: "تعديل المستخدم",
    userInformation: "عرض معلومات المستخدم",
    walletEdit: "تعديل معلومات محفظة المستخدم",
    userHistory: "سجل المستخدم",
    userNotificationsHistory: "سجل إشعارات المستخدم",
    notifications: "الإشعارات",
    createNotification: "إنشاء إشعار",
    editNotification: "تعديل الإشعار",
    adminNotifications: "إشعارات الإدارة",
    yourNotifications: "إشعاراتك",
    tickets: "التذاكر",
    createTicket: "تسجيل تذكرة جديدة",
    editTicket: "تعديل التذكرة",
    departments: "الأقسام",
    createDepartment: "قسم جديد",
    editDepartment: "تعديل القسم",
    adminTickets: "إدارة التذاكر",
    discounts: "الخصومات",
    createDiscount: "إنشاء خصم",
    editDiscount: "تعديل الخصم",
    workReports: "تقارير العمل",
    createWorkReport: "إنشاء تقرير عمل",
    callMonitoring: "مراقبة المكالمات",
    adminWorkReports: "إدارة تقارير العمل",
    editWorkReport: "عرض وتعديل تقرير العمل",
    panels: "اللوحات",
    createPanel: "إنشاء لوحة",
    editPanel: "تعديل اللوحة",
    transferRequests: "طلبات السحب",
    editTransferRequest: "تعديل طلب السحب",
    tariffs: "التعرفات",
    createTariff: "إنشاء تعرفة",
    editTariff: "تعديل التعرفة",
    requests: "الطلبات",
    viewUser: "عرض المستخدم",
    manageTransactions: "إدارة المعاملات",
    viewTransaction: "عرض المعاملة",
    manageConfigs: "إدارة الإعدادات",
    rbLandConfigs: "إدارة إعدادات روبوت لاند",
    editConfig: "تعديل الإعدادات",
    manageUsers: "إدارة المستخدمين",
    categories: "التصنيفات",
    createCategory: "إضافة تصنيف",
    editCategory: "تعديل التصنيف",
    content: "المحتوى",
    createContent: "إضافة محتوى",
    editContent: "تعديل المحتوى",
    addUserGuide: "إضافة دليل المستخدم",
    editUserGuide: "تعديل دليل المستخدم",
    roles: "الأدوار",
    editRole: "تعديل الدور",
    createRole: "إضافة دور",
    permissionTitle: "الصلاحيات",
    paymentGateways: "بوابات الدفع",
    editPaymentGateway: "تعديل بوابات الدفع",
    campaigns: "الحملات",
    createCampaign: "إنشاء حملة",
    editCampaign: "تعديل معلومات الحملة",
    adminCustomers: "العملاء",
    createCustomer: "إنشاء عميل",
    editCustomerInfo: "تعديل معلومات العميل",
    referrerCustomers: "عملاء المُعرّف",
    customerHistory: "سجل العميل",
    userProfile: "الملف الشخصي",
    editProfile: "تعديل الملف",
    inviteFriends: "دعوة الأصدقاء",
    personalInfo: "المعلومات الشخصية",
    editPersonalInfo: "تعديل المعلومات",
    changePassword: "تغيير كلمة المرور",
    newWallet: "محفظة جديدة",
  },
  profileView: {
    email: "الإيميل",
    balance: "الرصيد",
    personType: "نوع الشخص",
    currency: "ريال",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "عندك لوحة {title} صالحة لـ {days} يوم.",
    buyOrRenew: "لشراء أو تجديد لوحتك اضغط الزر تحت.",
    buyPanel: "شراء لوحة",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "إعدادات الملف",
    changePasswordTitle: "تغيير كلمة الدخول",
    changePasswordSubtitle: "غير كلمة دخول حسابك.",
    alertMessage: "لو ما دخلت كلمة مرور من قبل، فعّل خيار تعيين كلمة المرور.",
    currentPasswordLabel: "كلمة المرور الحالية",
    setPasswordLabel: "تعيين كلمة مرور",
    addPassword: "إضافة كلمة مرور",
    newPasswordLabel: "كلمة المرور الجديدة",
    repeatPasswordLabel: "تكرار كلمة المرور",
    saveChanges: "حفظ التغييرات",
  },
  profileOrders: {
    cardTitle: "الطلبات",
    openOrders: "الطلبات المفتوحة ({count})",
    closedOrders: "الطلبات المغلقة ({count})",
    noOrders: "لحد الآن ما عندك أي طلب",
  },
  personalInformation: {
    cardTitle: "معلومات الحساب الشخصي",
    cardSubtitle: "حدّث معلوماتك الشخصية.",
    cancel: "إلغاء",
    update: "تحديث",
    yourInfo: "معلوماتك",
    profilePicture: "صورة الملف",
    allowedFileTypes: "الصيغ المسموحة: png، jpg، jpeg.",
    pictureSize: "الصورة لازم تكون مربعة (مثلًا 480×480).",
    name: "الاسم",
    lastName: "اللقب",
    username: "اسم المستخدم",
    receiveSMS: "استقبال الرسائل",
    smsCostNote: "لو فعّلت هالخيار بيخصمون تكلفة الرسائل من حسابك.",
    phoneNumber: "رقم الجوال",
    phonePlaceholder: "رقم الجوال",
    email: "الإيميل",
    emailPlaceholder: "الإيميل",
    emailPrivacy: "إحنا أبدًا ما نعطي إيميلك لحد.",
    successMessage: "تم تحديث ملفك بنجاح.",
  },
  userInfoForm: {
    companyName: "اسم الشركة/المحل",
    registrationNumber: "رقم التسجيل",
    economicCode: "الكود الاقتصادي",
    organizationIdentity: "الرقم الوطني للمنظمة",
    companyType: "نوع الشركة",
    activity: "مجال النشاط",
    registrationAd: "صورة إعلان تسجيل الشركة",
    lastPublishedAd: "صورة آخر إعلان رسمي منشور",
    statute: "صورة النظام الأساسي للشركة",
    argentLetterPic: "صورة خطاب تعريف الوكيل",
    phone: "رقم الجوال",
    telephone: "رقم التلفون الأرضي",
    fatherName: "اسم الأب",
    nationalCode: "الرقم الوطني",
    id: "رقم الهوية",
    birthday: "تاريخ الولادة",
    placeBirthday: "مكان الولادة",
    postalCode: "البوستال كود",
    email: "الإيميل",
    introduction: "شلون عرفت علينا",
    nationalCodePic: "صورة البطاقة الوطنية",
    plaque: "رقم اللوحة",
    address: "العنوان الكامل",
    companyTypes: {
      governmental: "حكومي",
      private: "خاص",
      common_stock: "مساهمة عامة",
      special_stock: "مساهمة خاصة",
    },
    rules: {
      companyName: "حقل اسم الشركة أو المحل لازم تملاه.",
      registration_number: "حقل رقم التسجيل لازم تملاه.",
      economic_code: "حقل الكود الاقتصادي لازم تملاه.",
      organization_identity: "حقل الرقم الوطني للمنظمة لازم تملاه.",
      registration_ad: "حقل صورة إعلان التسجيل لازم تملاه.",
      last_published_ad: "حقل صورة آخر إعلان رسمي لازم تملاه.",
      telephone: "حقل رقم التلفون الأرضي لازم تملاه.",
      fatherName: "حقل اسم الأب لازم تملاه.",
      nationalCode: "حقل الرقم الوطني لازم تملاه.",
      id: "حقل رقم الهوية لازم تملاه.",
      birthday: "حقل تاريخ الولادة لازم تملاه.",
      placeBirthday: "حقل مكان الولادة لازم تملاه.",
      postalCode: "حقل البوستال كود لازم تملاه.",
      nationalCodePic: "حقل صورة البطاقة الوطنية لازم تملاه.",
      address: "حقل العنوان لازم تملاه.",
      plaque: "حقل رقم اللوحة لازم تملاه.",
    },
  },
  createUserForm: {
    name: "الاسم",
    lastName: "اللقب",
    nid: "الرقم الوطني",
    phone: "رقم الجوال",
    create: "خلّق",
    errors: {
      nameRequired: "الاسم ما دخلته!",
      lastNameRequired: "اللقب ما دخلته!",
      nidRequired: "الرقم الوطني ما دخلته!",
      phoneRequired: "رقم الجوال ما دخلته!",
    },
  },
  lastView: {
    cardTitle: "آخر زياراتك",
    cardSubtitle: "آخر الصفحات اللي دخلتها",
    tableHeaders: {
      page: "الصفحة",
      address: "العنوان",
      enterDate: "تاريخ الدخول للصفحة",
      leaveDate: "تاريخ الخروج من الصفحة",
      timeSpent: "الوقت اللي قضيته بالصفحة",
    },
    viewAll: "شوف الكل",
    timeUnit: "دقيقة",
    pages: {
      home: "الرئيسية",
      panels: "اللوحات",
      profile: "استكمال الملف",
    },
  },
walletWidget: {
  title: "المعاملات الأخيرة",
  balanceLabel: "رصيدك:",
  viewTransactions: "عرض المعاملات",
  transactionTypes: {
    withdraw: "سحب",
    deposit: "إيداع",
    charge: "شحن المحفظة",
    refund: "استرداد",
    default: "معاملة",
    adminCharge: "تعديل بواسطة المسؤول",
    agency: "عمولة الوكالة",
  },
},
  panelWidget: {
    title: "عندك لوحة {title} صالحة لـ {days} يوم.",
    renewPrompt: "عشان تشتري أو تجدد لوحتك اضغط الزر التحت.",
    buyPanel: "شراء لوحة",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} يوم",
  },
  component: {
    title: "الناس اللي دعيتهم",
    columns: {
      row: "الرقم",
      name: "الاسم",
      family: "اللقب",
      username: "اسم المستخدم",
      phone: "رقم الجوال",
      created_at: "تاريخ الانضمام",
      actions: "الإجراءات",
    },
    unknown: "ما نعرف",
    error: "خطأ",
    breadcrumb: "الناس اللي دعيتهم",
  },
  table: {
    itemsPerPage: "عدد الصفوف بالصفحة",
    pageText: "من {0} إلى {1} من {2} مدخل",
    prevText: "اللي قبل",
    nextText: "اللي بعد",
    noDataText: "ماكو شي",
    search: "دور",
  },
  UserHistory: {
    title: "سجل المستخدمين",
    add_history: "سجل جديد",
    send_message: "ارسل رسالة",
    close: "سكّر",
    save: "حفظ",
    cancel: "إلغاء",
    new_history_dialog_title: "سجل جديد",
    send_message_dialog_title: "ارسل رسالة",
    negotiations: "التفاوض اللي صار",
    follow_up: "اللي لازم نتابعهم بالمكالمة الجاية",
    success_history: "السجل انحفظ تمام.",
    success_message: "الرسالة طلعت تمام.",
    columns: {
      id: "الرقم",
      title: "العنوان",
      status: "المرحلة",
      current_time_date: "تاريخ آخر مكالمة",
      current_time_hour: "ساعة آخر مكالمة",
      next_time_date: "تاريخ المكالمة الجاية",
      next_time_hour: "ساعة المكالمة الجاية",
      user_id: "الدعم",
      actions: "الإجراءات",
    },
    table: {
      itemsPerPage: "عدد الصفوف بالصفحة",
      pageText: "من {0} إلى {1} من {2} مدخل",
      prevText: "اللي قبل",
      nextText: "اللي بعد",
      noDataText: "ماكو شي",
      search: "دور",
    },
    form: {
      title: "العنوان",
      status: "المرحلة",
      current_time: "تاريخ آخر مكالمة",
      description: "التفاصيل",
      next_time: "تاريخ المكالمة الجاية",
      pursue_text: "متابعة المكالمة الجاية",
      category: "اختار التصنيف",
      message_title: "عنوان الرسالة",
    },
  },
  newUserTransactions: {
    userWallet: "محفظة المستخدم",
    transactionList: "قائمة المعاملات",
    userTransactions: "معاملات المستخدم",
    terminal: "الترمينال",
    liveSms: "رسائل حية",
    realEstateNews: "آخر أخبار الديوان",
    rial: "ريال",
    row: "الرقم",
    uniqueId: "الرقم التعريفي",
    amount: "المبلغ",
    time: "الساعة",
    createdAt: "التاريخ",
    description: "تفاصيل زيادة",
    type: "نوع المعاملة",
    product_description: "الوصف",
    serviceId: "اسم الخدمة",
    balanceAfter: "الرصيد بعدين",
    perPage: "العدد",
    search: "دور",
    balance: "الرصيد",
    transactionListTooltip: "قائمة المعاملات",
    panelLogin: "دخول اللوحة",
    history: "السجل",
    error: {
      terminalWallet: "خطأ بجلب محفظة الترمينال",
    },
    transactionType: "نوع المعاملة",
    service: "الخدمة",
    dateFrom: "من تاريخ",
    dateTo: "لحد تاريخ",
    oldWallet: "المحفظة القديمة",
    depositReceipt: "وصل الإيداع",
    showReceipt: "ورّيني الوصل",
    transactionTypes: {
      online: "أونلاين",
      admin: "من الإدارة",
      refund: "تصحيحية",
      agency: "وكالة",
      withdraw: "سحب",
      deposit: "إيداع",
      adminCharge: "معاملة من الإدارة",
      charge: "شحن المحفظة",
      refund: "استرجاع",
    },
    error: {
      imageLoad: "خطأ بتحميل الصورة!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "انتبه زين وانت تختار نوع اللوحة!",
    },
    dialog: {
      title: "شراء لوحة",
      confirmPurchase: "متأكد تبي تشتري لوحة {title}؟",
      discountCodeLabel: "كود الخصم",
      discountCodePlaceholder: "دخل كود الخصم اللي عندك",
      applyDiscount: "سجل الكود",
      purchase: "اشتري",
      iHaveDiscount: "عندي كود خصم",
    },
    toast: {
      discountApplied: "كود الخصم انطبق تمام!",
      purchaseSuccess: "اللوحة اشتريتها بنجاح",
      error: "صار خطأ: {message}",
      unauthorized: "ادخل أول شي",
      validationError: "خطأ بالتحقق: {message}",
    },
    currency: "ريال",
  },
  panelCard: {
    rial: "ريال",
    days: "يوم",
    buyPanel: "شراء لوحة",
  },
  cons: {
    title: "اختار إيموجي",
  },
  cons1: {
    title: "نص افتراضي",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "منظومة ترمينال الإعلانات الجامبو",
  },
};
